import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface IntentConfirmData {
  intent_id: string;
  description: string;
  original_text: string;
}

interface IntentConfirmWidgetProps {
  data: IntentConfirmData;
  onAction?: (actionId: string, context?: Record<string, unknown>) => void;
}

/**
 * Lightweight "did you mean?" prompt for low-confidence intent matches.
 * Yes triggers the capability handler via sendAction.
 * No re-sends the original text as a regular chat message.
 *
 * Both paths set __dismiss to signal ChatShell to remove this widget
 * and show the thinking indicator while the result loads.
 */
export function IntentConfirmWidget({ data, onAction }: IntentConfirmWidgetProps) {
  return (
    <Card variant="default" padding="sm" className="max-w-sm animate-scale-in">
      <p className="text-sm text-daydra-text">{data.description}</p>
      <div className="flex gap-2 mt-2.5">
        <Button
          size="sm"
          onClick={() =>
            onAction?.("confirm_intent", {
              __action: "confirm_intent",
              __dismiss: true,
              __payload: {
                intent_id: data.intent_id,
                original_text: data.original_text,
              },
            })
          }
        >
          Yes
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            onAction?.(`[no_intent]${data.original_text}`, { __dismiss: true })
          }
        >
          No
        </Button>
      </div>
    </Card>
  );
}
